import { Logger, LoggerService } from '@Shared/logger';
import { Auth0Service, AuthModule, AuthProfile } from '@Modules/auth_module';
import { PipelineContext, PipelineStep } from '@Modules/pipeline_module/_base';

import { OptionsModule } from '@Modules/options_module';
import { ScreenManager } from '@Modules/ui_module';
import { EntitlementUtils } from '@Modules/entitlement_module';
import { SessionService } from '@Modules/session_module/services/session.service';
import { Auth0AuthenticatedStep } from '@Modules/pipeline_module/steps/auth/auth0-authenticated-step';

export class NotAuthenticatedStep implements PipelineStep {
  private sessionService: SessionService;
  private auth0Service: Auth0Service;
  private Logger: Logger = LoggerService.createLogger('NotAuthenticatedStep');
  async execute(context: PipelineContext): Promise<PipelineStep | null> {
    this.Logger.trace('Executing....');
    this.sessionService = SessionService.Instance;
    this.auth0Service = Auth0Service.Instance;
    //TODO: I should probably call EntitlementService.clearEntitlementState() here since there might be cases where i have cookies from parent domain.

    this.handleLoginDisplay();

    const res = await this.sessionService.getAuth0Session();
    this.Logger.trace('Auth State Result', res);
    context.checkAuthStatus = {
      isAuthenticated: res.isAuthenticated,
      user: res.AuthProfile,
    };

    if (context.checkAuthStatus.isAuthenticated) {
      context.sessionServerNeedsUpdate = false;
      return new Auth0AuthenticatedStep();
    }

    // If any logic to double-check authentication is added to this block, keep it above this.
    // This should only fire once it is determined that the user is not entitled
    // If entitlement check is enabled, and user is not entitled, we need to fire
    // the legacy entitlements ready event to play nice with legacy CMS functionality.
    if (OptionsModule.Options.entitlement.check) {
      EntitlementUtils.fireLegacyEntitlementsReadyEvent(false);
    } else this.handleLoginDisplay();

    return null;
  }

  private handleLoginDisplay(): void {
    const authOptions = AuthModule.AuthOptions;
    if (authOptions.mode.type === 'embedded') {
      const loginScreenOptions = OptionsModule.Options.ui.screens.login;

      // Show the login screen when autoShow is enabled, or whenever the
      // user is directed to the /login path (so the flow starts on landing).
      if (
        loginScreenOptions.autoShow === true ||
        this.auth0Service.shouldHandleLoginPath
      ) {
        this.Logger.info('Showing login screen', {
          autoShow: loginScreenOptions.autoShow,
          onLoginPath: this.auth0Service.shouldHandleLoginPath,
        });
        ScreenManager.Instance.showScreen('login');
      }
    } else {
      this.Logger.debug(
        'preferredAuthMode is NOT embedded, so not checking what screen to show',
      );
    }
  }
}

export type CheckSessionStepResultData = {
  isAuthenticated: boolean;
  AuthProfile?: AuthProfile;
};
